(function () {
    angular.module('tmx-app').directive('tmxFileInput', tmxFileInput);

    function tmxFileInput() {
        var directive = {};
        directive.scope = {
            name: '@',
            label: '@',
            value: '=',
            form: '=',
            required: '@',
            onChange: '&',
            onImageClick: '&',
            attachment: '=',
            dynamicField: '=',// only for dynamic form, ignore it and functions in which it occurs
            dynamicShow: '=',// only for dynamic form, ignore it and functions in which it occurs
            disabled: '=',
            applicationId: '=',
            guarantorId: '=',
            watermark: '=',
            updateImage: '='
        },
            directive.restrict = 'E',
            directive.templateUrl = 'common/directives/tmxfileinput/tmxfileinput.html',

            directive.controller = ["$scope", "$mdDialog", "tmxUtility", 'LoanApplicationService', '$q', '$timeout', '$window', fileInputCtrl];
        directive.controllerAs = "fileInputCtrl";
        return directive;
    }

    function fileInputCtrl($scope, $mdDialog, tmxUtility, LoanApplicationService, $q, $timeout, $window) {
        if (!angular.isDefined($scope.disabled)) {
            $scope.disabled = false;
        }
        var exists = tmxUtility.exists;
        var fileInputCtrl = this;
        fileInputCtrl.scope = $scope;
        if (!exists(fileInputCtrl.scope.value)) {
            fileInputCtrl.scope.value = '';
        }
        if (!exists($scope.watermark)) {
            $scope.watermark = {
                font: '14px Josefin Slab',
                text: '',
                color: '#A8210E',
                opacity: '1',
            }
        }
        else if (typeof $scope.watermark == 'string') {
            $scope.watermark = {
                font: '14px Josefin Slab',
                text: $scope.watermark,
                color: '#A8210E',
                opacity: '1',
            }
        }
        function updateIsChecked(newVal, oldVal) {
            if (newVal != oldVal) {
                $scope.isChecked = newVal;
                $scope.onchange();
            }
        }
        function shouldBeChecked() {
            return exists($scope.value) && $scope.value.length > 0 || exists($scope.fileURL);
        }
        $scope.isChecked = shouldBeChecked();
        if ($scope.attachment) {
            $scope.value = $scope.attachment;
        }
        $scope.$watch(shouldBeChecked, updateIsChecked);

        var validFormats = ['jpg', 'png', 'gif', 'jpeg', 'bmp', 'tiff', 'tif', 'pdf', 'xls', 'xlsx', 'doc', 'docx'];

        $scope.upload = function (files) {
            var file;
            if (exists(files) && files.length > 0) {
                if (files.length == 1) {
                    file = files[0];
                    handleSingleFile(file);
                    return;
                }
                else if (files.length > 1) {
                    handleMultipleFiles(files);
                    return;
                }
            }
            function handleSingleFile(file) {
                if (exists(file)) {
                    if (validFormats.indexOf(file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase()) < 0) {
                        $mdDialog.show(
                            $mdDialog.alert()
                                .parent(angular.element(document.body))
                                .clickOutsideToClose(true)
                                .title('Invalid File')
                                .textContent('File format invalid')
                                .ariaLabel('File format invalid')
                                .ok('OK')
                        );
                        return;
                    }
                    var allowedFileSize = 2; //MB
                    if (file.name.includes(".pdf") || file.name.includes(".xlsx") || file.name.includes(".xls") || file.name.includes(".tiff") || file.name.includes(".tif") || file.name.includes(".doc") || file.name.includes(".docx")) {
                        allowedFileSize = 10;
                    }
                    if (file.size > (allowedFileSize * 1024 * 1024)) {
                        $mdDialog.show(
                            $mdDialog.alert()
                                .parent(angular.element(document.body))
                                .clickOutsideToClose(true)
                                .title('Invalid File')
                                .textContent('File size must be less than ' + allowedFileSize + ' MB')
                                .ariaLabel('File size must be less than ' + allowedFileSize + ' MB')
                                .ok('OK')
                        );
                        return;
                    }

                    if (!(file.name.includes(".pdf") || file.name.includes(".xlsx") || file.name.includes(".xls") || file.name.includes(".tiff") || file.name.includes(".tif") || file.name.includes(".doc") || file.name.includes(".docx"))) {
                        watermark([file])
                            .image(watermark.text.lowerRight($scope.watermark.text, $scope.watermark.font, $scope.watermark.color, $scope.watermark.opacity))
                            .then(function (img) {
                                $scope.updateImage(img.src);
                            });
                    }
                    else {
                        $scope.getBase64(file);
                    }
                }
            }

            function handleMultipleFiles(files) {
                let allowedFileSize = 2; //2MB
                let multipleUploadValidFormats = ['jpg', 'png', 'gif', 'jpeg', 'bmp'];
                let fileSummary = files.map(file => ({
                    extension: file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase(),
                    name: file.name.substring(0, file.name.lastIndexOf(".")),
                    size: file.size
                }));

                if (fileSummary.some(file => multipleUploadValidFormats.indexOf(file.extension)< 0)) {
                    $mdDialog.show(
                        $mdDialog.alert()
                            .parent(angular.element(document.body))
                            .clickOutsideToClose(true)
                            .title('Invalid File format')
                            .textContent('One or more files are in invalid format.')
                            .ariaLabel('File format invalid')
                            .ok('OK')
                    );
                    return;
                }
                if (fileSummary.some(file => file.size > (allowedFileSize * 1024 * 1024))) {
                    $mdDialog.show(
                        $mdDialog.alert()
                            .parent(angular.element(document.body))
                            .clickOutsideToClose(true)
                            .title('Invalid File')
                            .textContent('File size must be less than ' + allowedFileSize + ' MB')
                            .ariaLabel('File size must be less than ' + allowedFileSize + ' MB')
                            .ok('OK')
                    );
                    return;
                }
                var doc = new jsPDF();
                var processedFiles = 0;

                files.forEach(function (file) {
                    var reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = function () {
                        $timeout(function () {
                            processedFiles++;
                            let imgData = reader.result;
                            doc.addImage(imgData, 'JPEG', 10, 40, 180, 160, 'image_' + processedFiles, 'MEDIUM');
                            if (processedFiles >= files.length) {
                                handleJSPDFOutput(doc.output('datauristring'));
                            }
                            else {
                                doc.addPage();
                            }
                        });
                    };
                    reader.onerror = function (error) {
                        console.log('Error: ', error);
                    };
                });
            }
            function handleJSPDFOutput(pdfOutput) {
                let dataURI = pdfOutput.replace(/filename=[a-zA-Z0-9]+\.pdf?;/,""); // remove filename to avoid problems in mimetype logic
                $scope.attachment = dataURI;
                $scope.fileURL = $scope.attachment;
            }
        }

        $scope.getBase64 = function (file) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                $timeout(function () {
                    $scope.attachment = reader.result;
                    $scope.fileURL = $scope.attachment;
                });
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
        }

        $scope.updateImage = function (file) {
            var deferred = $q.defer();
            var myImage = new Image();
            myImage.src = file;
            myImage.onload = function () {

                $timeout(function () {
                    var canvas = document.createElement('canvas');
                    canvas.width = myImage.width;
                    canvas.height = myImage.height;
                    var ctx = canvas.getContext('2d');
                    ctx.fillStyle = "white";
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    ctx.drawImage(myImage, 0, 0, canvas.width, canvas.height);
                    var dataUrl = canvas.toDataURL('image/jpeg', 0.8);
                    $scope.fileURL = dataUrl;
                    $scope.attachment = dataUrl;
                    $scope.value = "ignore" + Math.random();
                    deferred.resolve();
                });
            }


            return deferred.promise;
        }

        $scope.isImage = function () {

            if ($scope.value) {
                if ($scope.value.indexOf('.jpg') > -1 || $scope.value.indexOf('.png') > -1) {
                    $scope.fileURL = $scope.value;
                    return 1;
                }
            }

            if ($scope.attachment) {
                if ($scope.attachment.indexOf('data:image/jpeg;base64') > -1) {
                    // $scope.fileURL  = $scope.attachment;
                    return 1;
                }
            }

            return 0;
        }

        $scope.isTiff = function () {

            if ($scope.value) {
                if ($scope.value.indexOf('.tiff') > -1 || $scope.value.indexOf('.tif') > -1) {
                    $scope.fileURL = $scope.value;
                    return 1;
                }
            }

            if ($scope.attachment) {
                if ($scope.attachment.includes('data:image/tiff;base64') || $scope.attachment.includes('data:image/tif;base64')) {
                    return 1;
                }
            }

            return 0;
        }

        $scope.isHtml = function () {
            if ($scope.value) {
                if (($scope.value.indexOf('.text/html') > 1 || $scope.value.indexOf('.html') > 1)) {
                    return 1;
                }
            }

            if ($scope.attachment) {
                if (($scope.attachment.indexOf('.text/html') > 1 || $scope.attachment.indexOf('.html') > 1)) {
                    return 1;
                }
            }
            return 0;
        }


        $scope.openLink = function (url) {
            if (url) {
                $window.open(url, "_blank");
            }
        }

        $scope.isPdf = function () {
            if ($scope.value) {
                if ($scope.value.indexOf('.pdf') > -1) {
                    return 1;
                }
            }
            if ($scope.attachment) {
                if ($scope.attachment.indexOf('data:application/pdf') > -1) {
                    return 1;
                }
            }
            return 0;
        }
        $scope.isDoc = function () {
            if ($scope.value) {
                if ($scope.value.indexOf('.doc') > -1) {
                    return 1;
                }
            }
            if ($scope.attachment) {
                if ($scope.attachment.indexOf('data:application/msword') > -1) {
                    return 1;
                }
            }
            return 0;
        }
        $scope.isExcel = function () {
            if ($scope.value) {
                if ($scope.value.indexOf('.xlsx') > -1) {
                    return 1;
                }
            }
            if ($scope.attachment) {
                if ($scope.attachment.indexOf('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') > -1) {
                    return 1;
                }
            }
            return 0;
        }
        function showRemoveConfirmDialog() {
            var confirm = $mdDialog.confirm()
                .title('Alert!')
                .textContent('Are you sure you want to delete?.')
                .targetEvent(event)
                .ok('Yes')
                .cancel('No').multiple(true);
            $mdDialog.show(confirm).then(function () {
                if (exists($scope.fileURL)) {
                    delete $scope.fileURL;
                    delete $scope.file;
                    delete $scope.attachment;
                    $scope.value = "";
                }
                else {
                    delete $scope.file;
                    delete $scope.attachment;
                    $scope.value = "";
                }

            }, function () {

            });
        }
        $scope.cancel = function () {
            showRemoveConfirmDialog();
        }
        $scope.onchange = function () {
            // if (angular.isFunction($scope.onChange())) {
            //$scope.onChange()($scope.value, $scope);
            fileInputCtrl.scope.onChange({ value: fileInputCtrl.scope.value, scope: fileInputCtrl.scope });
            // }
        }

        $scope.imageClick = function () {
            var value = null;
            if ($scope.isImage() == 1) {
                value = (!$scope.fileURL && $scope.value && ($scope.value.length > 0) && $scope.value.indexOf('ignore') != 0) ? $scope.value : $scope.fileURL;
            }
            else if ($scope.value && $scope.value.indexOf('http') > -1 && $scope.isImage() != 1) {
                value = $scope.value;
            }
            else if ($scope.isImage() == 0) {
                value = 'assets\images\attachment.png';
            }
            $scope.onImageClick()(value, $scope.dynamicField);
        }

        $scope.viewDocHistory = function () {
            if ($scope.dynamicField.table && $scope.dynamicField.table.match(/TmxLoanApplicationChecklist{"LoanProductChecklistId":(\d+)}/i) != null) {
                var ProductChecklistId = $scope.dynamicField.table.match(/TmxLoanApplicationChecklist{"LoanProductChecklistId":(\d+)}/i)[1];
                LoanApplicationService.getChecklistHistory($scope.applicationId, ProductChecklistId).then(function (response) {
                    if (response.data && response.data.length > 0) {
                        $mdDialog.show({
                            controller: DocumentHistoryCtrl,
                            templateUrl: 'common/directives/tmxfileinput/documentHistoryDialog.html',
                            parent: angular.element(document.body),
                            locals: {
                                Data: response.data,
                                Label: $scope.label,
                            },
                            clickOutsideToClose: true
                        });
                    }
                    else {
                        $mdDialog.show(
                            $mdDialog.alert()
                                .parent(angular.element(document.body))
                                .clickOutsideToClose(true)
                                .title($scope.label + ' History')
                                .textContent('No history found for this document.')
                                .ariaLabel('No history found for this document.')
                                .ok('OK')
                                .multiple(true)
                        );
                    }
                });
            }
            else
                if ($scope.dynamicField.table && $scope.dynamicField.table.match(/TmxGuarantorChecklist{"ProductChecklistId":(\d+)}/i) != null) {
                    var ProductChecklistId = $scope.dynamicField.table.match(/TmxGuarantorChecklist{"ProductChecklistId":(\d+)}/i)[1];
                    LoanApplicationService.getGuarantorChecklistHistory($scope.guarantorId, ProductChecklistId).then(function (response) {
                        if (response.data && response.data.length > 0) {
                            $mdDialog.show({
                                controller: DocumentHistoryCtrl,
                                templateUrl: 'common/directives/tmxfileinput/documentHistoryDialog.html',
                                parent: angular.element(document.body),
                                locals: {
                                    Data: response.data,
                                    Label: $scope.label,
                                },
                                clickOutsideToClose: true,
                                multiple: true
                            });
                        }
                        else {
                            $mdDialog.show(
                                $mdDialog.alert()
                                    .parent(angular.element(document.body))
                                    .clickOutsideToClose(true)
                                    .title($scope.label + ' History')
                                    .textContent('No history found for this document.')
                                    .ariaLabel('No history found for this document.')
                                    .ok('OK')
                                    .multiple(true)
                            );
                        }
                    });
                }
                else
                if ($scope.dynamicField.form_name && $scope.dynamicField.ProductChecklistId) {
                    var ProductChecklistId = $scope.dynamicField.ProductChecklistId;
                    LoanApplicationService.getGuarantorChecklistHistory($scope.guarantorId, ProductChecklistId).then(function (response) {
                        if (response.data && response.data.length > 0) {
                            $mdDialog.show({
                                controller: DocumentHistoryCtrl,
                                templateUrl: 'common/directives/tmxfileinput/documentHistoryDialog.html',
                                parent: angular.element(document.body),
                                locals: {
                                    Data: response.data,
                                    Label: $scope.label,
                                },
                                clickOutsideToClose: true,
                                multiple: true
                            });
                        }
                        else {
                            $mdDialog.show(
                                $mdDialog.alert()
                                    .parent(angular.element(document.body))
                                    .clickOutsideToClose(true)
                                    .title($scope.label + ' History')
                                    .textContent('No history found for this document.')
                                    .ariaLabel('No history found for this document.')
                                    .ok('OK')
                                    .multiple(true)
                            );
                        }
                    });
                }
        }

        $scope.scanDocument = function () {
            $mdDialog.show({
                controller: 'scanDocumentDialog',
                templateUrl: 'common/directives/tmxfileinput/scanDocumentDialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
            }).then(function (image) {
                if (image) {
                    $scope.updateImage(image);
                }
            });
        }

        function DocumentHistoryCtrl($scope, $mdDialog, $window, Data, Label) {
            $scope.Data = Data;
            $scope.Label = Label + ' History';
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.openLink = function (url) {
                if (url) {
                    $window.open(url, "_blank");
                }
            }

            $scope.isPdf = function (attachmentUrl) {
                if (attachmentUrl && attachmentUrl.indexOf('.pdf') > 1) {
                    return 1;
                }
                else {
                    return 0;
                }
            }

            $scope.isHtml = function (attachmentUrl) {
                if (attachmentUrl && (attachmentUrl.indexOf('.text/html') > 1 || attachmentUrl.indexOf('.html') > 1)) {
                    return 1;
                }
                else {
                    return 0;
                }
            }

            $scope.isImage = function (attachmentUrl) {
                if (attachmentUrl && attachmentUrl.indexOf('.jpg') > 1) {
                    return 1;
                }
                else {
                    return 0;
                }
            }
            $scope.isExcel = function (attachmentUrl) {
                if (attachmentUrl && attachmentUrl.indexOf('.xlsx') > 1) {
                    return 1;
                }
                else {
                    return 0;
                }
            }

            $scope.formatDate = function (date) {
                return moment(date).add(-(new Date().getTimezoneOffset()), 'minutes').format('D MMM YYYY hh:mm a');
            }
            $scope.openImageWindow = function (index) {
                var images = [];
                for (var i = 0; i < $scope.Data.length; i++) {
                    var image = {
                        src: $scope.Data[i].AttachmentURL,
                        label: Label,
                    }
                    images.push(image);
                }
                localStorage.setItem('imagePreview', JSON.stringify(images));
                var uri = "common/directives/dynamicpage/imagePreview.html?img=" + encodeURIComponent(index);
                var newwindow = window.open(uri, 'Image Preview ' + imagePreviewPopups.length, 'height=600,width=600');
                imagePreviewPopups.push(newwindow);
                // var html = '<img style="width: 100%;" src="'+src+'" />';
                // var uri = "data:text/html," + encodeURIComponent(html);
                // var newwindow=window.open(uri,'Image Preview ' + imagePreviewPopups.length,'height=600,width=600');
                // imagePreviewPopups.push(newwindow);
            }
        }
    }
})();